<div class="confirm-dialog-container" data-cy="fee-calculation-error">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="fee-calculation-error-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="fee-calculation-error-header">
      <div class="section-header-title" data-cy="fee-calculation-error-title">
        Something's Missing ...
      </div>
      <div style="flex: 1;" data-cy="fee-calculation-error-header-spacer"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; text-align: left; margin-top: 12px;" data-cy="fee-calculation-error-content">
      <div *ngIf="message" style="white-space: pre; display: flex; height: 285px; overflow-y: auto" data-cy="fee-calculation-error-message">
        {{ message }}
      </div>
      <div *ngIf="errorObj" style="height: 285px; overflow-y: auto" data-cy="fee-calculation-error-grid">
        <div style="display: flex" data-cy="fee-calculation-error-header-row">
          <div style="flex:1" class="colHeader_code" data-cy="fee-calculation-error-header-code">Code</div>
          <div style="flex:1;" class="colHeader_fail warn" data-cy="fee-calculation-error-header-required">Required</div>
          <div style="flex:1" class="colHeader_optional" data-cy="fee-calculation-error-header-optional">Optional</div>
        </div>

        <div style="display: flex" *ngFor="let item of this.errorObj.ARFeeErrorItems; let i = index" [class.offset-item]="i % 2" data-cy="fee-calculation-error-row">
          <div style="flex:1;" class="rowCell" data-cy="fee-calculation-error-code">
            {{ item.transactionItemCode }}
          </div>
          <div style="flex:2;" class="rowCell" data-cy="fee-calculation-error-fields">

          <div  *ngIf="item.errorListRequired.length > 0" data-cy="fee-calculation-error-required-container">
            <div *ngFor="let field of item.errorListRequired" class="colHeader_fail rowCell" data-cy="fee-calculation-error-required-field">
              {{ field }}
            </div>
          </div>
          <div *ngIf="item.errorListOptional.length > 0" data-cy="fee-calculation-error-optional-container">
            <div *ngFor="let field of item.errorListOptional" class="colHeader_optional rowCell" data-cy="fee-calculation-error-optional-field">
              {{ field }}
            </div>
          </div>
          </div>
        </div>

      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="fee-calculation-error-footer">
      <div style="flex: 1; margin-right: 6px;" data-cy="fee-calculation-error-footer-spacer"></div>
      <button *ngIf="showCancel" (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="fee-calculation-error-cancel-btn">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="fee-calculation-error-ok-btn">Ok</button>
    </div>
  </div>
</div>
